import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { Store } from '@ngrx/store';

import { selectSelectedChannel } from '../../../../store/app.selectors';
import { BaseComponent } from '../../../../modules/shared/components/base/base.component';
import { LogActions, LogModules, LogsService } from '../../services/logs.service';
import { setSmartReplieSelected, setSmartRepliesStatus } from '../../store/chat.actions';
import { AppStateWithChat } from '../../store/chat.reducer';

@Component({
  selector: 'smart-replies',
  templateUrl: './smart-replies.component.html',
  styleUrls: ['./smart-replies.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SmartRepliesComponent extends BaseComponent {
  private store = inject(Store<AppStateWithChat>);
  private logsService = inject(LogsService);

  selectedChannel = toSignal(this.store.select(selectSelectedChannel), { initialValue: null });

  sendSuggestion(text: string) {
    this.logsService.sendLog(LogModules.SMARTREPLIES, LogActions.CLICK).subscribe();
    this.store.dispatch(setSmartReplieSelected({ messages: text }));
    setTimeout(() => {
      this.store.dispatch(setSmartReplieSelected({ messages: null }));
    });
  }

  closeSmartReplies(): void {
    this.store.dispatch(setSmartRepliesStatus({ value: true, channel: this.selectedChannel()! }));
  }
}
